/**
 * First recipe save: name + 1 shopping-list ingredient + selling price.
 * Auto-create Uncategorised when the venue has no categories.
 * Do not require notes / method / menus / image / category picker.
 */

export const UNCATEGORISED_CATEGORY_NAME = 'Uncategorised'

export function isSlimFirstRecipeCreate({ update = false, recipes } = {}) {
  if (update) return false
  return !Array.isArray(recipes) || recipes.length === 0
}

function categoryNameKey(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
}

export function findUncategorisedCategory(categories = []) {
  const list = Array.isArray(categories) ? categories : []
  return (
    list.find(category => {
      const name = categoryNameKey(category?.name)
      return name === 'uncategorised' || name === 'uncategorized'
    }) || null
  )
}

export function firstRecipeHasShoppingListIngredient(ingredients = []) {
  return (
    Array.isArray(ingredients) &&
    ingredients.some(
      ingredient =>
        ingredient &&
        (ingredient.productId || ingredient._id || ingredient.venueProductId),
    )
  )
}

export function hasRecipeSellingPrice(sellingPrice) {
  if (sellingPrice === '' || sellingPrice == null) return false
  const price = Number(sellingPrice)
  return Number.isFinite(price) && price > 0
}

export function canSaveSlimFirstRecipe({
  title,
  ingredients,
  sellingPrice,
} = {}) {
  const name = String(title || '').trim()
  if (!name) return false
  if (!firstRecipeHasShoppingListIngredient(ingredients)) return false
  return hasRecipeSellingPrice(sellingPrice)
}

/**
 * First save always has a category id: Uncategorised if present, otherwise
 * the first existing category, otherwise create Uncategorised (Chico’s).
 */
export async function ensureUncategorisedCategory({
  categories = [],
  createCategory,
} = {}) {
  const existing = findUncategorisedCategory(categories)
  if (existing?._id) return existing
  const list = Array.isArray(categories) ? categories.filter(Boolean) : []
  if (list.length > 0) return list[0]
  if (typeof createCategory !== 'function') return null
  const created = await createCategory(UNCATEGORISED_CATEGORY_NAME)
  return created?._id ? created : null
}
